// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";

import { logout } from "../../../../store/globalActions";

import { useMediaQuery } from "../../../../hooks/useMediaQuery";

import { UserCard } from "../../../User/UserCard/UserCard";

import { PopOver } from "../../../UI/PopOver/PopOver";

import { Button } from "../../../../../web-utils/src/UI/Component/React/V1/Button/Button";
import { LinkComponent } from "../../../../../web-utils/src/UI/Component/React/V1/LinkComponent/LinkComponent";

import styles from "../Navigation.module.css";
import button from "../../../UI/Button/Button.module.css";

export const UserNavigation = ({ adminLinks, isLocalUser }) => {
  const { user } = useSelector((state) => state.user, shallowEqual);
  const { companies } = useSelector((state) => state.companies);

  const isMobile = useMediaQuery("(max-width: 768px)");

  const dispatch = useDispatch();

  const handleClearUser = () => {
    dispatch(logout(isLocalUser));
  };

  return (
    <PopOver
      color=""
      iconType="user"
      fill="var(--color-light)"
      stroke="none"
      hoverEffect={true}
      classname={button.btnNavigation}
      buttonText={isMobile ? "User" : null}
    >
      <div className={styles.navItemContainer}>
        <div className={styles.padding}>
          <div className={styles.borderBottom}>
            <UserCard user={user} flexDirection="column" />
          </div>
          {!!companies?.length && (
            <div className={styles.borderBottom}>
              {adminLinks.map(({ id, to, iconType, label }) => (
                <LinkComponent
                  key={id}
                  href={to}
                  iconType={iconType}
                  stroke="var(--color-light)"
                >
                  {label}
                </LinkComponent>
              ))}
            </div>
          )}
          <div className={styles.item}>
            <Button
              color="light"
              onClick={handleClearUser}
              tooltipText={`Logout`}
              position="left"
              iconType="logout"
              sizing
            >
              Log out
            </Button>
          </div>
        </div>
      </div>
    </PopOver>
  );
};
